<template>
    <el-form label-width="150px" class="normalForm"
    >
        <el-form-item label="活動日期" :disabled="true">
            <el-tag>
                {{form.range[0] | shortDate}}
                ~
                {{form.range[1] | shortDate}}
            </el-tag>
        </el-form-item>
        <el-form-item label="時段">
            <el-tag
                    v-for="period in periods"
                    :key="period.periodId"
                    style="margin-right: 2px;"
            >
                {{`${period.tag}(${period.timeBegin}~${period.timeEnd})`}}
            </el-tag>
        </el-form-item>
        <el-form-item label="活動名稱摘要">
            <el-input
                    type="textarea"
                    :value="form.activity"
                    resize="none"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="參加人數">
            <el-input
                    :value="form.numberOfParticipants"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="參加對象">
            <el-input
                    :value="form.participants"
                    type="textarea"
                    resize="none"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="連絡電話">
            <el-input
                    :value="form.contact"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="郵件信箱">
            <el-input
                    :value="form.email"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="單位主管或指導老師">
            <el-input
                    :value="form.advisor"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="器材數量">
            <el-input
                    :value="form.equipments"
                    type="textarea"
                    resize="none"
                    size="mini"
            ></el-input>
        </el-form-item>
        <el-form-item label="檢附文件">
            <small>※活動企劃書(練習及社團時間免附計畫書)或簽核文件</small>
            <div style="margin: 0;padding: 0">
                <a
                        style="margin: 0;padding: 0"
                        href="#"
                        v-for="download in form.downloads"
                        :key="download.key"
                        type="info"
                        @click.prevent="click(download)"
                >
                    {{download.fullName}}
                </a>
            </div>
        </el-form-item>
    </el-form>
</template>

<script>
    import {mapActions} from 'vuex';
    import moment from 'moment';

    const defaultForm = {
        activity: '',
        numberOfParticipants: 1,
        participants: '',
        equipments: '',
        advisor: '',
        range: [],
        contact: '',
        details: [],
        email:''
    };

    export default {
        name: 'NormalForm',
        props: {
            form: {
                type: Object,
                default: () => ({...defaultForm}),
                required: true
            }
        },
        computed: {
            periods() {
                return (this
                    .form
                    .eventPeriods || []);
            }
        },
        methods: {
            ...mapActions({
                download: 'downloadFileAction'
            }),
            async click(download) {
                await this.download(download);
            }
        },
        filters: {
            shortDate(date) {
                if (date) {
                    return moment(date).format('YYYY-MM-DD');
                }
                return '';
            }
        }
    }
</script>

<style>
    .normalForm .el-alert {
        cursor: pointer;
    }
</style>